import { render } from "./Footer.vue?vue&type=template&id=2787ad3a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2787ad3a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1190997001/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2787ad3a"]])

export default __exports__